import { useMutation } from "@tanstack/react-query"

import { httpClient } from "~/backend/axios.ts"
import { queryClient } from "~/backend/queryClient.ts"

export const useMarkNotificationArchivedMutation = () => {
  return useMutation({
    mutationFn: (id: number) =>
      Promise.all([httpClient.post(`/notifications/${id}/mark-as-archived`)]),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["notifications"] })
    },
  })
}
